import { LatamAiPage } from '@/screens/Latam/AI/LatamAiPage';

export default function HomePage() {
  return <LatamAiPage locale="es-MX" />;
}
